export default __webpack_public_path__ + "static/media/project-wizard-communication.7566d022.png";